import ChatStep from './ChatStep.js';
import ChoiceStep from './ChoiceStep.js';
import ContactStep from './ContactStep.js';
import DocumentStep from './DocumentStep.js';
import EscalateStep from './EscalateStep.js';
import FormStep from './FormStep.js';
import HandoffStep from './HandoffStep.js';
import LookupStep from './LookupStep.js';
import SubmitStep from './SubmitStep.js';
import { ASSISTANT, CHOICE, CONTACT, DOCUMENT, ESCALATE, FORM, HANDOFF, LOOKUP, SUBMIT } from '../engine/nodes.js';

/*
 * Step, the switchboard
 *
 * One line per node type, and nothing else. The engine decides which node the
 * customer is on; this only decides which component draws it.
 *
 * Keeping the mapping in one file is what stops the node vocabulary from
 * growing by accident: a seventh type cannot be quietly introduced by a tree
 * author, because a tree that uses one lands on the unknown-type branch here
 * and the validator has already refused it.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const RENDERERS = {
  [ASSISTANT]: ChatStep,
  [CHOICE]: ChoiceStep,
  [CONTACT]: ContactStep,
  [DOCUMENT]: DocumentStep,
  [ESCALATE]: EscalateStep,
  [FORM]: FormStep,
  [HANDOFF]: HandoffStep,
  [LOOKUP]: LookupStep,
  [SUBMIT]: SubmitStep
};
const Step = ({
  node,
  ...props
}) => {
  const Renderer = RENDERERS[node?.type];
  if (!Renderer) {
    // Only reachable if a tree ships a node type the validator would have
    // caught. Says so plainly rather than rendering an empty screen.
    console.error(`[SupportCenter] no renderer for node type "${node?.type}"`);
    return null;
  }
  return /*#__PURE__*/_jsx(Renderer, {
    node: node,
    ...props
  });
};
export default Step;